import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterEligibiliteBeneficiaireByNamePipe } from 'src/app/shared/pipes/filter-eligibiliteBeneficiaire-by-name/filter-eligibiliteBeneficiaire-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { EligibiliteBeneficiaireModalDetailComponent } from './modal/eligibiliteBeneficiaire-modal-detail/eligibiliteBeneficiaire-modal-detail.component';
import { EligibiliteBeneficiaireModalAjoutComponent } from './modal/eligibiliteBeneficiaire-modal-ajout/eligibiliteBeneficiaire-modal-ajout.component';
import { ListEligibiliteBeneficiaireComponent } from './list-amenagement/list-eligibiliteBeneficiaire.component';

@NgModule({
	declarations: [
		ListEligibiliteBeneficiaireComponent,
		EligibiliteBeneficiaireModalDetailComponent,
		EligibiliteBeneficiaireModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterEligibiliteBeneficiaireByNamePipe]
})

export class EligibiliteBeneficiaireModule {}
